import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';
import { ErrorCode } from '../constants/error-codes';
import { SearchDataType, TmfPublishing, Topic, TopicField } from '../utils/topic-utils';
import { MassCodingActivityType } from '@app/origami-api/constants/mass-coding-activity-type';
import { MAX_NO_OF_ROWS } from '@app/origami-api/constants/server-boundaries';

//todo: may be take out that interface in another place
export interface IAuditStatus {
  CreatedBy: number;
  CreatedDate: string;
  LockedBy: number;
  ParentId: number;
  SiteId: number;
  TopicFields: {
    FieldId: number;
    FieldName: string;
    FieldType: number;
    Fieldvalue: string;
  }[];
  TopicId: number;
  TopicName: string;
  TopicTypeId: number;
  AuditStatusTopicId?: number;
}

export namespace TopicSearchServiceOptions {
  export interface SearchTopics {
    siteId: number;
    parentId?: number;
    topicTypeId: number;
    searchQuery?: string;
    collectionId?: number;
    fieldListing?: string;
    startingRow?: number;
    noOfRows?: number;
    liveTopicsOnly?: boolean;
    collectionName?: string;
    securityGroup?: any;
    saveCollection?: any;
    relatedTopics?: number[];
    saveSearchToHistory?: boolean;
    additionalTopicTypeIds?: number[];
    module?: any;
    tmfPublishing?: TmfPublishing;
    ftsQueryDataType?: SearchDataType;
    ftsQuery?: string;
    searchByFieldsInIndex?: boolean;
  }

  export interface CrossSiteSearchTopics {
    searchQuery: string;
    fields?: string[];
    numberOfRows?: number;
    startingRow?: number;
    searchRequestId?: number;
    ftsQueryDataType?: SearchDataType;
    ftsQuery?: string;
  }

  export interface MassCodingSearchTopicsParams {
    SearchQuery?: string;
    TopicIds: number[];
    TopicTypeId: number;
    FtsQuery?: string;
    FtsQueryDataType?: SearchDataType;
    SearchByFieldsInIndex?: boolean;
  }

  export interface MassCodingDocumentsByViewParams {
    ParentId?: number;
    ViewMode: number;
    SearchQuery: string;
    Search: string;
  }

  export interface MassCodingFilter {
    OutputFormat: number;
  }

  export interface MassCoding {
    siteId: number;
    fieldInfo: TopicField[];
    searchTopicsParams?: MassCodingSearchTopicsParams;
    getDocumentsByViewParams?: MassCodingDocumentsByViewParams;
    filter?: MassCodingFilter;
    activityType?: MassCodingActivityType;
  }
}

export namespace TopicSearchServiceModel {
  export interface SearchTopicsResult {
    SearchRequestId?: number;
    TopicList: Topic[];
    TotalRowCount: number;
    errCodeAddTopicsToCollection?: number[];
    errCodeCreateCollection?: any[];
  }

  export interface MassCodingResult {
    JobId: string;
  }
}

@Injectable()
export class TopicSearchService extends ServiceBase {
  serviceUrl = 'TopicSearchService.svc';

  searchTopics(
    options: TopicSearchServiceOptions.SearchTopics,
    force: boolean = true,
  ): Observable<OrigamiResponse<TopicSearchServiceModel.SearchTopicsResult>> {
    options = Object.assign(
      {
        searchQuery: '',
        collectionId: 0,
        fieldListing: '',
        noOfRows: MAX_NO_OF_ROWS,
      },
      options,
    );

    return this.origamiPost(
      '/SearchTopics',
      options,
      null,
      [ErrorCode.NO_RESULTS_FOUND, ErrorCode.FIELD_MAP_DOES_NOT_EXIST],
      force,
    );
  }

  massCoding(
    options: TopicSearchServiceOptions.MassCoding,
  ): Observable<OrigamiResponse<TopicSearchServiceModel.MassCodingResult>> {
    return this.origamiPost('/MassCoding', options, null, null, true);
  }

  crossSiteSearchTopics(
    body: TopicSearchServiceOptions.CrossSiteSearchTopics,
    force?: boolean,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiResponse<TopicSearchServiceModel.SearchTopicsResult>> {
    force = force === true || force === undefined;
    body = Object.assign(
      {
        searchQuery: '',
        numberOfRows: MAX_NO_OF_ROWS,
        startingRow: 0,
        searchRequestId: 0,
      },
      body,
    );

    return this.origamiPost('/CrossSiteSearchTopics', body, null, silentErrorCodes, force);
  }

  getAll(siteId: number, topicTypeId: number, searchQuery?: string) {
    return this.searchTopics({
      siteId,
      searchQuery: searchQuery || null,
      topicTypeId,
    });
  }

  exportTopics(
    params,
  ): Observable<
    OrigamiResponse<{ ApproximateDocumentArchiveSize: number; JobId: string; MaxDocumentArchiveSizeExceeded: boolean }>
  > {
    return this.origamiPost('/ExportTopics', params, null, null, true);
  }

  printTopics(params): Observable<any> {
    return this.origamiPost('/PrintTopics', params, null, null, true);
  }
}
